import { DotLegalPaper } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { TaskLaneStateEnum, TaskRawStateEnum } from "../../../../annualWheel/AnnualWheel.types";
import { getTaskDeadLine, getTaskResponsible, getTaskSubTasks } from "../../../../taskManagement/task/Task";
import { getTaskColor, useTaskStyles } from "../../../../taskManagement/task/Task.styles";
import { useTranslation } from "../../../../localization/useTranslation";
import { TaskResponsibleViewModel } from "../../../../taskManagement/TaskManagement.types";
import { AnnualWheelPriority } from "../../../../annualWheel/annualWheelDialog/AnnualWheelDialog.types";
import TaskHeader from "../../../../taskManagement/task/TaskHeader.tsx";
import React from "react";
import { EvaluationStatus } from "../../../../common/components/questionnaireComponents/evaluateQuestionnaireDialog/EvaluateQuestionnaireDialog.types.ts";

export interface ITasksWidgetReportTaskProps {
    activityName: string;
    taskName: string;
    responsibles: Array<TaskResponsibleViewModel>;
    deadline: Date;
    subTaskCompleted: number;
    totalSubTasks: number;
    taskStatus: TaskLaneStateEnum;
    priority: AnnualWheelPriority;
    isOverdue: boolean;
    customId?: string;
    isReadyForApproval: boolean;
    isAdhocTask: boolean;
    evaluationStatus?: EvaluationStatus;
    taskId: string;
}

function TasksWidgetReportTask(props: ITasksWidgetReportTaskProps) {
    const { translateString, translateDate } = useTranslation();
    const styles = useTaskStyles(props.taskStatus, props.isOverdue);

    return (
        <div className="avoid-page-break">
            <DotLegalPaper sx={styles.root}>
                <Box
                    sx={(_) => ({
                        display: "flex",
                        width: "100%",
                        height: "100%",
                        minHeight: "55px",
                    })}
                >
                    <Box
                        sx={(theme) => ({
                            backgroundColor: getTaskColor(
                                props.isReadyForApproval ? TaskRawStateEnum.ReadyForApproval : props.taskStatus,
                                theme,
                                props.isOverdue
                            ),
                            marginRight: theme.spacing(2),
                            borderRadius: "12px",
                            paddingRight: "6px",
                        })}
                    />

                    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, "& > .MuiBox-root": { marginTop: "2px", marginBottom: "2px" } }}>
                        <TaskHeader {...props} />
                        <Grid container>
                            <Grid size={4}>
                                <Box>{getTaskDeadLine(styles, translateDate(props.deadline))}</Box>
                            </Grid>

                            <Grid size={4}>
                                <Box>{getTaskResponsible(props.responsibles, styles, translateString)}</Box>
                            </Grid>

                            <Grid size={4}>
                                <Box sx={styles.taskContainter}>
                                    {props.totalSubTasks > 0 && getTaskSubTasks(styles, props.subTaskCompleted, props.totalSubTasks)}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </DotLegalPaper>
        </div>
    );
}

export default TasksWidgetReportTask;
